import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import styled from "styled-components";
import { Stack } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#545454",
        color: theme.palette.common.white,
        fontSize: "12px",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 12,
    },
}));

const Title = styled.p`
    margin: 0;
    font-size: 12px;
`;

const SubTitle = styled.p`
    margin: 0;
    font-size: 12px;
    opacity: 0.9;
    font-weight: 200;
`;

const ContentText = styled.p`
    margin: 0;
    font-size: 12px;
`;

const ConfigTable = ({ data }) => {
    if (!data) return null;

    const columns = [
        { id: "repo", label: "Repo", minWidth: 170 },
        { id: "defaultConfig", label: "Default\u00a0Config", minWidth: 100 },
        { id: "deployments", label: "Deployments", minWidth: 100 },
        { id: "pipelines", label: "Pipelines", minWidth: 100 },
        { id: "releases", label: "Releases", minWidth: 100 },
        { id: "webhook", label: "Webhook", minWidth: 100 },
    ];

    function createData(repo, defaultConfig, deployments, pipelines, releases, webhook) {
        return { repo, defaultConfig, deployments, pipelines, releases, webhook };
    }

    const rows = Object.entries(data).map(([repo, repoData]) => {
        const defaultConfig = repoData.defaultConfig ? <Title>True</Title> : <Title>False</Title>;
        const deployments = (
            <Stack>
                <SubTitle>Environment:</SubTitle>
                <ContentText>
                    {repoData.deployments?.environment ?? (
                        <ContentText style={{ opacity: 0.5 }}>N/A</ContentText>
                    )}
                </ContentText>
            </Stack>
        );
        const pipelines = (
            <Stack>
                <SubTitle>Workflow:</SubTitle>
                <ContentText style={{ marginBottom: "6px" }}>
                    {repoData.pipelines?.workflow ?? (
                        <ContentText style={{ opacity: 0.5 }}>N/A</ContentText>
                    )}
                </ContentText>
                <SubTitle>Branch:</SubTitle>
                <ContentText>
                    {repoData.pipelines?.branch ?? (
                        <ContentText style={{ opacity: 0.5 }}>N/A</ContentText>
                    )}
                </ContentText>
            </Stack>
        );
        const releases = (
            <Stack>
                <SubTitle>Name:</SubTitle>
                <ContentText>
                    {repoData.releases?.name ?? (
                        <ContentText style={{ opacity: 0.5 }}>N/A</ContentText>
                    )}
                </ContentText>
            </Stack>
        );
        const webhook = repoData.webhook ? <Title>True</Title> : <Title>False</Title>;

        return createData(repo, defaultConfig, deployments, pipelines, releases, webhook);
    });

    return (
        <Paper sx={{ width: "100%", overflow: "hidden", borderRadius: "0 0 14px 14px" }}>
            <TableContainer sx={{ maxHeight: 440, borderRadius: "0 0 14px 14px" }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <StyledTableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </StyledTableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        const value = row[column.id];
                                        return (
                                            <StyledTableCell key={column.id} align={column.align}>
                                                {column.format && typeof value === "number"
                                                    ? column.format(value)
                                                    : value}
                                            </StyledTableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};
export default ConfigTable;
